var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import notifications from 'antd/lib/notification';
import 'antd/lib/notification/style/index.css';
import FaComments from 'react-icons/lib/fa/comments';
var selfStyles = require('./styles.scss');
var MenuItemGroupBottom = (function (_super) {
    __extends(MenuItemGroupBottom, _super);
    function MenuItemGroupBottom() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MenuItemGroupBottom.prototype.render = function () {
        return (React.createElement("li", { className: "ant-menu-item-group " + selfStyles.menuItemGroupBottom },
            React.createElement("div", { className: "ant-menu-item " + selfStyles.menuOption },
                React.createElement(ButtonLiveChat, null))));
    };
    return MenuItemGroupBottom;
}(React.Component));
var ButtonLiveChat = function () { return (React.createElement("div", { className: selfStyles.menuItemButton, onClick: handleLaunchDrift },
    React.createElement(FaComments, null),
    " Talk to us!")); };
function handleLaunchDrift() {
    try {
        window.drift.api.sidebar.toggle();
    }
    catch (err) {
        notifications.open({
            message: 'Error with Chat Service',
            description: (React.createElement("span", null,
                "Your adblocker may be blocking our third-party chat app. Please disable it to chat with us.",
                React.createElement("br", null),
                React.createElement("br", null),
                "You can also reach us at ",
                React.createElement("a", { href: 'mailto:hello@crimp.rocks', target: '_blank' }, "hello@crimp.rocks"),
                ".")),
            duration: 5,
            placement: 'bottomLeft',
        });
    }
}
export default MenuItemGroupBottom;



//////////////////
// WEBPACK FOOTER
// ./src/pages/templates/components/PageMenu/MenuItemGroupBottom.tsx
// module id = 363
// module chunks = 0